import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserEditComponent } from '@routes/users/user-edit/user-edit.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import Configs from '@shared/constants/configs';
import { AuthService } from '@core/auth/auth.service';
import { ApiService } from '@shared/apis';
import Utils from '@shared/utils/utils';
import { AssignDealerComponent } from '@routes/users/assign-dealer/assign-dealer.component';
import { UserService } from '@routes/users/shared/user.service';
import Roles from '@shared/constants/roles';
import { AssignLocationAliasComponent } from '@routes/users/assign-location-alias/assign-location-alias.component';
import { Company } from '@shared/enums/company';
import Role from '@shared/constants/role';
import { Constants } from '@shared/constants/constants';


@Component({
  selector: 'app-user-detail', templateUrl: './user-detail.component.html', styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {
  readonly constants = Constants;
  readonly color = Configs.badgeColor;
  isAdmin = false;
  isUssiAdmin = false;
  isDealerManager = false;
  query: any;
  q: any;
  options = { autoHide: true, scrollbarMaxSize: 100 };
  bsModalRef: BsModalRef;
  userDetail: any = {};
  userDetailCompanyName: any;
  roles;
  dealerCodes: any[] = [];
  companyCodes: any[] = [];
  @Output() detailUpdateEvent = new EventEmitter();
  isEditable = false;
  isAdminViewerRole: boolean;
  isDealer: false;
  company;
  isDealerSupervisor = false;
  userType = Constants.userType;
  companies = Company;
  view: 'LOCATION_ALIAS' | 'ACTIVITY_SUMMARY' = 'ACTIVITY_SUMMARY';

  constructor(
    private modalService: BsModalService,
    private authService: AuthService,
    private apiService: ApiService,
    private userService: UserService,
  ) {
    this.isAdmin = this.authService.hasType(Roles.admin);
    this.isUssiAdmin = this.authService.hasType(Roles.ussiAdmin);
    this.isDealer = this.authService.hasType(Roles.dealer);
    this.isDealerManager = this.authService
      .getRoles()
      ?.some(role => role?.groups?.includes(Role.dealerManager));
    this.company = this.authService.getCurrentCompany();
    this.isDealerSupervisor = this.authService.hasRoleInCompany(Role.secaDealerSuperVisor);
    this.isAdminViewerRole = this.authService.checkHasAdminViewerRole();
  }

  @Input() set userInfo(value) {
    if (!Utils.isEmpty(value)) {
      this.userDetail = value;
      //TODO: Get User OrganizationName
      this.roles = this.userDetail.roles?.find(f => f.company === this.company)?.groups?.map(g => this.constants.role[g])?.join(', ');
      const hasLocationAlias = [this.userType.be, this.userType.ussi, this.userType.ra].includes(this.userDetail?.userType);
      this.view = this.isAdmin ? 'ACTIVITY_SUMMARY' : hasLocationAlias ? 'LOCATION_ALIAS' : this.view;
    }
  }

  showSubItem(view: 'LOCATION_ALIAS' | 'ACTIVITY_SUMMARY') {
    this.view = view;
  }

  ngOnInit(): void {
    this.isEditable = ([Company.SeaIm, Company.Seca].includes(this.company) && this.isDealerSupervisor) || this.isAdmin || this.isDealerManager;
    this.userService.detailReload$.subscribe(res => {
      if (res) {
        this.detailUpdateEvent.emit('detailReload');
      }
    });
  }

  modalOpen() {
    const initialState = {
      title: 'User Edit', userInfo: this.userDetail
    };
    this.bsModalRef = this.modalService.show(UserEditComponent, { initialState, class: 'modal-lg' });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.detailUpdateEvent.emit(result)
      }
    });
  }

  dealerOpen() {
    const initialState = {
      userInfo: this.userDetail
    };
    this.bsModalRef = this.modalService.show(AssignDealerComponent, { initialState, class: 'modal-lg' });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.detailUpdateEvent.emit(this.userDetail)
      }
    });
  }

  locationAliasOpen() {
    const initialState = {
      userInfo: this.userDetail
    };
    this.bsModalRef = this.modalService.show(AssignLocationAliasComponent, { initialState, class: 'modal-lg' });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.detailUpdateEvent.emit(this.userDetail)
      }
    });
  }

}
